// Pet Service
import apiService from '@/services/api'


class PetService {
  async getPets(params?: any) {
    const response = await apiService.api.get('/admin/pets', { params })
    return response.data
  }

  async getAllPets() {
    const response = await apiService.api.get('/admin/pets/all')
    return response.data
  }

  async getPet(id: number | string) {
    const response = await apiService.api.get(`/admin/pets/${id}`)
    return response.data
  }

  async createPet(data: any) {
    const response = await apiService.api.post('/admin/pets', data)
    return response.data
  }

  async updatePet(id: number | string, data: any) {
    const response = await apiService.api.put(`/admin/pets/${id}`, data)
    return response.data
  }

  async deletePet(id: number | string) {
    await apiService.api.delete(`/admin/pets/${id}`)
  }

  async getPetsByUser(userId: number) {
    const response = await apiService.api.get(`/admin/users/${userId}/pets`)
    return response.data
  }

  async uploadPetImage(petId: number, file: File) {
    const formData = new FormData()
    formData.append('image', file)
    
    const response = await apiService.api.post(`/admin/pets/${petId}/image`, formData, { headers: { 'Content-Type': null as any } })
    
    return response.data
  }

  // Método para obtener estadísticas de mascotas
  async getPetStats() {
    const response = await apiService.api.get('/admin/pets/stats')
    return response.data
  }
}

export const petService = new PetService()
export default petService